// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"0711a264","265":"c0b1ea44","604":"066d9b59","710":"61c4792e","807":"2a3c042a","818":"b3e8506e","899":"987bd315","900":"a8d08fcf","996":"d7bdcd8d"}[chunkId] + ".chunk.js";
};